export default __webpack_public_path__ + "static/media/whatsapp-blue.7ddb2f5e.svg";